import { useState } from "react";
import { Link } from "react-router-dom";
import { apiClient, formatApiErrorDetail } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await apiClient.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (e) {
      setError(formatApiErrorDetail(e.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-24" data-testid="forgot-password-page">
      <h1 className="text-2xl font-display font-medium text-slate-900 text-center mb-2">Reset Password</h1>
      <p className="text-sm text-slate-500 text-center mb-8">Enter your email to receive a reset link.</p>
      {sent ? (
        <p className="text-sm text-emerald-600 text-center" data-testid="forgot-password-success">If an account with that email exists, a reset link has been sent.</p>
      ) : (
        <form onSubmit={handleSubmit} className="space-y-4">
          <div><Label>Email</Label><Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-password-email-input" /></div>
          {error && <p className="text-xs text-red-500">{error}</p>}
          <Button type="submit" disabled={loading} className="w-full rounded-full btn-lift" data-testid="forgot-password-submit-btn">
            {loading ? "Sending..." : "Send Reset Link"}
          </Button>
        </form>
      )}
      <p className="text-sm text-slate-500 text-center mt-5"><Link to="/login" className="text-brandblue-600 font-semibold">Back to Research Login</Link></p>
    </div>
  );
}
